<template>
  <div>
    <el-popover
      ref="popover"
      placement="right-start"
      width="330"
      trigger="hover">
      <image-component :image="{image: img, width: 0, height: 0}" :width='300'></image-component>
    </el-popover>
    <image-component :image="{image: img, width: 0, height: 0}" v-popover:popover :width="60"></image-component>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
  }
}
</script>
